import React from 'react'
import { Grid } from '@material-ui/core'
import { Label } from '@progress/kendo-react-labels'
import { ComboBox } from '@progress/kendo-react-dropdowns'
import './comboBox-template.css'
import TooltipHLPure from '../tooltipHL/tooltipHL.pure'
import LabelErrorPure from '../labelErrorPure/labelErrorPure'

const ComboBoxTemplatePure = (props) => {
  const { title, required, errorCombobox, errorMessage, tooltipShow, positionTooltip, titleTooltip, descriptionTooltip, subContent, restContent, informationIcon } = props

  return (
    <Grid item lg={12} md={12} sm={12} es={12} >
      <div className='comboBoxTemplatePure-label-container'>
        <Label className="label-tax-data">{title}{required && " *"}</Label>
        {tooltipShow && (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        )
        }
      </div>
      <ComboBox
        type='text'
        {...props}
      />
      {
        errorCombobox && 
        <LabelErrorPure label={errorMessage}/>
      }
    </Grid>
  )
}

export { ComboBoxTemplatePure as default }
